export const path = "/master-tag-roundler";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "MASTER TAG",
  section: "ROUNDLER",
  group: null,
  order: 2,
  roles: [
    "Authenticated",
    "roundler-admin",
  ],
};
